"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8078],{

/***/ 8078:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FooterHotel; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(155);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9741);







function FooterHotel(param) {
    var _bg = param.bg, bg = _bg === void 0 ? "black" : _bg, _color = param.color, color = _color === void 0 ? "white" : _color, _logo = param.logo, logo = _logo === void 0 ? "" : _logo, location = param.location, locationLink = param.locationLink, email = param.email, phone = param.phone, instagram = param.instagram, facebook = param.facebook, hotelSlug = param.hotelSlug;
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)(), query = ref.query, push = ref.push, locale = ref.locale;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(2022), year = ref1[0], setYear = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        setYear(new Date().getFullYear());
    }, []);
    var listOurGrup = {
        en: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Homepage"
                })
            }, 0),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: hotelSlug ? "/".concat(hotelSlug, "/about") : "/about",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "About Us"
                })
            }, 1),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Our Brands"
                })
            }, 2),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Our Collections"
                })
            }, 3),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Development"
                })
            }, 4),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/gallery",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Media"
                })
            }, 5), 
        ],
        id: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Halaman Depan"
                })
            }, 0),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: hotelSlug ? "/".concat(hotelSlug, "/about") : "/about",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Tentang Kami"
                })
            }, 1),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Merek Kami"
                })
            }, 2),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/gallery",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Koleksi Kami"
                })
            }, 3),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Pengembangan"
                })
            }, 4),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: "/gallery",
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Media"
                })
            }, 5), 
        ]
    };
    var listPage = {
        en: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/special-offers",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Special Offers"
                })
            }, 0),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/wedding",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Wedding"
                })
            }, 1),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/meeting-events",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Meeting & Events"
                })
            }, 2),
            // <NextLink key={4} passHref href={`https://www.shop.parador-hotels.com/`}>
            //   <Link _focus={{}}>Store</Link>
            // </NextLink>,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/blog",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Blog"
                })
            }, 5),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/contact",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Contact Us"
                })
            }, 6),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: hotelSlug && hotelSlug !== "parador" ? "/".concat(hotelSlug, "/faq") : "/faq",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Faq"
                })
            }, 7), 
        ],
        id: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/special-offers",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Promo Spesial"
                })
            }, 0),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/wedding",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Pernikahan"
                })
            }, 1),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/meeting-events",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Rapat & Acara"
                })
            }, 2),
            // <NextLink key={4} passHref href={`https://www.shop.parador-hotels.com/id/`}>
            //   <Link _focus={{}}>Toko</Link>
            // </NextLink>,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/blog",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Blog"
                })
            }, 5),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: "/contact",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Kontak"
                })
            }, 6),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                passHref: true,
                href: hotelSlug && hotelSlug !== "parador" ? "/".concat(hotelSlug, "/faq") : "/faq",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                    _focus: {},
                    children: "Faq"
                })
            }, 7), 
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        direction: "column",
        as: "footer",
        bg: bg,
        py: 10,
        gap: 10,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                justify: {
                    lg: "flex-start",
                    base: "unset"
                },
                pt: 8,
                mb: 2,
                w: "100%",
                gap: 12,
                px: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                    w: [
                        "140px",
                        "160px"
                    ],
                    ml: [
                        0,
                        "-6px"
                    ],
                    cursor: "pointer",
                    onClick: function() {
                        return push("/");
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .Eep, {
                        objectFit: "contain",
                        src: "https://backend.parador-hotels.com/wp-content/uploads/2022/05/Parador_White.png",
                        alt: "Parador_White"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                mx: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                // flexDir={!isLarge && `column`}\
                justify: {
                    lg: "space-between",
                    base: "flex-start"
                },
                gap: {
                    base: 8,
                    lg: 0
                },
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: locale == "id" ? "lokasi kami" : "our location",
                        list: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                mb: 8,
                                href: locationLink !== null && locationLink !== void 0 ? locationLink : "https://goo.gl/maps/ts41ZxoKT3hBSiZy5",
                                isExternal: true,
                                _focus: {},
                                children: location !== null && location !== void 0 ? location : "Soho Office Park Kav. 9, 3rd Floor, Jl. Boulevard Raya Gading, Serpong, Tangerang, Banten 15810"
                            }, 0),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                href: "mailto:".concat(email !== null && email !== void 0 ? email : "hello@parador-hotel.com"),
                                style: {
                                    wordWrap: "normal"
                                },
                                isExternal: true,
                                _focus: {},
                                children: email !== null && email !== void 0 ? email : "hello@parador-hotel.com"
                            }, 1),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                href: "tel:".concat(phone !== null && phone !== void 0 ? phone : "(+62) 2917 - 1111"),
                                style: {
                                    wordWrap: "normal"
                                },
                                isExternal: true,
                                _focus: {},
                                children: phone !== null && phone !== void 0 ? phone : "(+62) 2917 - 1111"
                            }, 2), 
                        ],
                        hasBackButton: true
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: locale == "id" ? "grup kami" : "our group",
                        list: locale == "id" ? listOurGrup.id : listOurGrup.en
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: locale == "id" ? "halaman" : "page",
                        list: locale == "id" ? listPage.id : listPage.en
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        title: "sitemap",
                        list: locale == "id" ? listSitemap.id : listSitemap.en
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isRow: true,
                        title: locale == "id" ? "Tetap Terhubung" : "stay connected",
                        list: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                _focus: {},
                                href: "https://www.instagram.com/".concat(instagram !== null && instagram !== void 0 ? instagram : "paradorhotels"),
                                isExternal: true,
                                _hover: {
                                    color: "white"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoLogoInstagram */ .oVe, {
                                    size: 32,
                                    color: "inherit"
                                })
                            }, 0),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                _focus: {},
                                href: "https://www.facebook.com/".concat(facebook !== null && facebook !== void 0 ? facebook : "ParadorHotelsGroup"),
                                isExternal: true,
                                _hover: {
                                    color: "white"
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoLogoFacebook */ .egd, {
                                    size: 32
                                })
                            }, 1), 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                mx: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Divider */ .izJ, {
                    mt: 3,
                    borderWidth: 0.5,
                    py: 0.1,
                    opacity: 0.2,
                    borderColor: "white",
                    bg: "white",
                    orientation: "horizontal"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
                mx: _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_6__/* .safeMarginX */ .Mp,
                justify: {
                    lg: "space-between",
                    base: "flex-start"
                },
                gap: {
                    base: 8,
                    lg: 0
                },
                flexWrap: "wrap",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Atria Hotel",
                        list: [
                            "Gading Serpong",
                            "Magelang",
                            "Malang"
                        ],
                        target: [
                            "atria-hotel-gading-serpong",
                            "atria-hotel-magelang",
                            "atria-hotel-malang", 
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Atria residences",
                        list: [
                            "Gading Serpong"
                        ],
                        target: [
                            "atria-residences-gading-serpong"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Vega Hotel",
                        list: [
                            "Gading Serpong"
                        ],
                        target: [
                            "vega-hotel-gading-serpong"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Fame Hotel",
                        list: [
                            "Gading Serpong",
                            "Sunset Road"
                        ],
                        target: [
                            "fame-hotel-gading-serpong",
                            "fame-hotel-sunset-road"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(FooterList, {
                        isHotel: true,
                        title: "Starlet Hotel",
                        list: [
                            "Jakarta Airport",
                            "BSD City",
                            "Serpong"
                        ],
                        target: [
                            "starlet-hotel-jakarta-airport",
                            "starlet-hotel-bsd-city",
                            "starlet-hotel-serpong", 
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
                my: 6,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
                    color: "whiteAlpha.800",
                    fontSize: "sm",
                    children: [
                        locale == "id" ? "Hak Cipta Dilindungi" : "Copyright",
                        " \xa9 ",
                        year
                    ]
                })
            })
        ]
    });
};
function FooterList(param) {
    var title = param.title, list = param.list, isRow = param.isRow, target = param.target, _isHotel = param.isHotel, isHotel = _isHotel === void 0 ? false : _isHotel, _hasBackButton = param.hasBackButton, hasBackButton = _hasBackButton === void 0 ? false : _hasBackButton;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        direction: "column",
        maxW: {
            lg: "15%",
            base: "100%"
        },
        mb: {
            base: 6,
            lg: 0
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6q, {
                color: "whiteAlpha.600",
                fontSize: "md",
                mb: 4,
                fontWeight: 500,
                as: "h4",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .UnorderedList */ .QI$, {
                color: "whiteAlpha.800",
                listStyleType: "none",
                m: 0,
                style: isRow && {
                    display: "flex",
                    gap: 20
                },
                children: [
                    list.map(function(item, i) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .ListItem */ .HCh, {
                            fontSize: "sm",
                            mb: 2,
                            children: isHotel ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                href: "/".concat(target[i]),
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                    _focus: {},
                                    children: item
                                })
                            }) : item
                        }, i);
                    }),
                    hasBackButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xuv, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: "/",
                            passHref: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                                _focus: {},
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                                fontSize: "sm",
                                mt: 8,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoChevronBack */ .dUf, {}),
                                    " ",
                                    locale == "id" ? "Kembali ke Parador" : "Back to Parador"
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var listSocial = [
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "https://www.instagram.com/paradorhotels",
        isExternal: true,
        _hover: {
            color: "red.300"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoLogoInstagram */ .oVe, {
            size: 32,
            color: "inherit"
        })
    }, 0),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "https://www.facebook.com/ParadorHotelsGroup/",
        isExternal: true,
        _hover: {
            color: "facebook.400"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_5__/* .IoLogoFacebook */ .egd, {
            size: 32
        })
    }, 1), 
];
var listLocation = [
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        mb: 8,
        href: "https://goo.gl/maps/ts41ZxoKT3hBSiZy5",
        isExternal: true,
        children: "Soho Office Park Kav. 9, 3rd Floor, Jl. Boulevard Raya Gading, Serpong, Tangerang, Banten 15810"
    }, 0),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "mailto:hello@parador-hotel.com",
        isExternal: true,
        children: "hello@parador-hotel.com"
    }, 1),
    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
        _focus: {},
        href: "tel:+6229171111",
        isExternal: true,
        children: "(+62) 2917 - 1111"
    }, 2), 
];
var listSitemap = {
    en: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/help-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Offers Help Center"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "https://parador-hotels.com/special-offers/group",
            isExternal: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Why Book Direct"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/privacy-policy",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Privacy & Policy"
            })
        }, 2),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/career",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Career"
            })
        }, 3), 
    ],
    id: [
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/help-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Pusat Bantuan"
            })
        }, 0),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "https://parador-hotels.com/special-offers/group",
            isExternal: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Kenapa Pesan Langsung"
            })
        }, 1),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "/privacy-policy",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Privasi & Kebijakan"
            })
        }, 2),
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
            passHref: true,
            href: "https://parador-hotels.com/",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .rUS, {
                _focus: {},
                children: "Karir"
            })
        }, 3), 
    ]
};


/***/ })

}]);